import { Skeleton, View } from 'native-base';

import { styles } from './styles';

export function SelectorLoading() {
  return (
    <>
      <View style={styles.horizontalContainer}>
        <Skeleton height="27px" width="40px" rounded="xs" />
        <Skeleton.Text
          lines={2}
          _line={{
            height: '12px',
          }}
          space="$2"
          flex={1}
        />

        <Skeleton
          width="72px"
          height="30px"
          rounded="2xl"
          marginY="$6"
          marginRight="$3"
          marginLeft={{ base: '$1', md: '$6' }}
        />
      </View>
    </>
  );
}
